import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http'
import { inject } from '@angular/core'
import { Observable, throwError } from 'rxjs'
import { catchError } from 'rxjs/operators'

import { AuthService } from '../services/auth.service'
import { HelperService } from '../services/helper.service'
import { SKIP_AUTH_HEADER } from '../tokens/http-context.token'

export function accessTokenInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
	if (req.context.get(SKIP_AUTH_HEADER)) {
		return next(req)
	}

	let nextRequest = req
	const authService = inject(AuthService)
	const helperService = inject(HelperService)
	const accessToken = authService.getAccessToken()
	const isRenew = req.url.includes('renew')
	const refreshToken = authService.getRefreshToken()

	if (accessToken) {
		nextRequest = nextRequest.clone({
			headers: nextRequest.headers.set('Authorization', `Bearer ${accessToken}`).set('Content-Type', 'application/json'),
			params: req.params.set('locale', helperService.locale),
		})
	}

	if (isRenew && refreshToken) {
		nextRequest = nextRequest.clone({
			headers: nextRequest.headers.set('refresh-token', refreshToken),
		})
	}

	return next(nextRequest).pipe(
		catchError((err) => {
			if (req.headers.has('Refresh-Token') || req.headers.has('refresh-token') || req.url.includes('/auth/renew')) {
				authService.logOut()
			}

			return throwError(() => err)
		}),
	)
}
